<mat-dialog-content>
    <p>{{'NameYourContract' | translate }}</p>
    <mat-form-field>
        <mat-label>{{'ContractName' | translate }}</mat-label>
        <input matInput [(ngModel)]="data.name">
    </mat-form-field>
    <div class="actions">
        <button mat-button mat-stroked-button color="primary" class="cancel" mat-dialog-close="">
            {{'Cancel' | translate }}
        </button>
        <button mat-button mat-flat-button color="primary" [mat-dialog-close]="data.name" cdkFocusInitial>{{'Save' | translate }}</button>
    </div>
</mat-dialog-content>